import { LengthUnits } from '../enums';

export const lengthUnitFactors: {[key: string]: {[key: string]: number;}} = {
  [LengthUnits.meter]: {
    [LengthUnits.mile]: 0.00062137,
    [LengthUnits.feet]: 3.280839895,
  },
};

